import React, { useEffect, useMemo, useState } from "react"
import { Milestone, MilestoneStep } from "../../../types/collaborations/CollaborationTypes"
import withSlideUpModal from "../../../utils/hoc/withSlideUpModal"
import AddressBook from "../../address/AddressSelection"
import { SavedAddress } from "../../../types/address"
import { useParams } from "react-router-dom"
import { submitMilestoneStep } from "../../../services/api/collaboration"
import { toast } from "react-toastify"

interface AddressSelectionProps {
    activeMilestone: Milestone,
    isActive: boolean,
    onClose: (refetch?: boolean) => void,
    step: MilestoneStep
}
const AddressSelection: React.FC<AddressSelectionProps> = ({ onClose, step }) => {

    const { campaignId } = useParams();
    const [submitting, setSubmitting] = useState(false);
    const [addingNew, setAddNew] = useState(false);

    const [selectedAddress, setSelectedAddress] = useState<SavedAddress | null>(null);

    const submitAddress = async () => {
        if (!campaignId || submitting || !selectedAddress) return;
        try {
            setSubmitting(true);
            await submitMilestoneStep(campaignId, { step: step.gig_step.slug, 'address': selectedAddress.uuid });
            onClose(true);
        } catch (error:any) {
            console.log(error);
            toast.error(error?.response?.data?.message ?? "Unknown error occurred.")
        } finally {
            setSubmitting(false);
        }
    }

    useEffect(() => {
        if(addingNew){
            const modalTitleElement = document.getElementById('address-selection-modal-title');
            if(modalTitleElement){
                modalTitleElement.innerText = "Add New Address";
            }
        }
    }, [addingNew])

    return (
        <>
            <AddressBook
                onSelection={(address) => setSelectedAddress(address)}
                toggleAddNewSection={(add) => setAddNew(add)}
            />
            {
                !addingNew &&
                <div className="milestone-step-actions px-3 pb-5">
                    <button className="btn btn-outline-primary" onClick={() => onClose()}>Cancel</button>
                    <button className="btn btn-primary" disabled={!selectedAddress || submitting} onClick={submitAddress}>Submit</button>
                </div>
            }
        </>
    )
}


const AddressSelectionModal: React.FC<AddressSelectionProps> = (props) => {
    const title = `Select Address`

    const ModalComponent = useMemo(() => withSlideUpModal(AddressSelection, title, true, "address-selection-modal"), [title])
    return <ModalComponent {...props} />
}


export default AddressSelectionModal;